import CompanyForm from './CompanyForm.vue'
export {CompanyForm}
export default CompanyForm

